import React from "react";
import { Button } from "@mui/material";

const GenericButton = ({
  onClick,
  children,
  hideIcon,
  backgroundColor,
  fontColor,
  borderColor,
  icon: IconComponent,
  padding,
  fontSize,
  disabled,
  margin,
  ...props
}) => {
  return (
    <Button
      variant="contained"
      onClick={onClick}
      disabled={disabled}
      sx={{
        backgroundColor: disabled ? "#f0f0f0" : backgroundColor || "#fff",
        color: disabled ? "#a1a1a1" : fontColor || "#000",
        border: borderColor ? `1px solid ${borderColor}` : "none",
        borderRadius: "4px",
        padding: padding || "0 30px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: margin || "10px 0",
        fontSize: fontSize || "16px",
        boxShadow: "none",
        width: "100%",
        pointerEvents: disabled ? "none" : "auto",
        "&:hover": {
          backgroundColor: disabled ? "#f0f0f0" : backgroundColor || "#fff",
        },
        "&:active, &:focus": {
          backgroundColor: disabled ? "#f0f0f0" : backgroundColor || "#fff",
        },
      }}
      {...props}
    >
      {!hideIcon && IconComponent && (
        <IconComponent
          sx={{ fontSize: fontSize || "16px", marginRight: "8px" }}
        />
      )}
      {children}
    </Button>
  );
};

export default GenericButton;
